import React, { useRef, useState } from "react";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { connect } from "react-redux";
import {
    setDescriptionValueAction,
    clearDescriptionFieldAction,
    addCharacteristicAction,
    cleanDescriptionErrorsAction,
    getMapCharacteristicsAction,
    changeRateAction,
} from "../../../redux/actions/mapCharacteristics";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ToggleButton from "@material-ui/lab/ToggleButton";
import { useStyles } from "./styles";
import { notify } from "react-notify-toast";
import { useWindowSize } from "../../../helpers/hooks/useWindowSize";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import LandscapeIcon from "@material-ui/icons/Landscape";

const MountainCharacteristic = (props) => {
    const classes = useStyles();
    const containerRef = useRef();
    const windowSize = useWindowSize();
    const [sendDReq, setSendDReq] = useState(true);
    const isMobile = windowSize.width < 530;
    const [isOpenSelect, setIsOpenSelect] = useState(false);

    const calculateRating = (percent) => {
        if (!percent || percent === 50) return { down: 0, up: 0 };
        if (percent > 90) return { down: 0, up: 100 };
        if (percent > 80) return { down: 0, up: 80 };
        if (percent > 70) return { down: 0, up: 60 };
        if (percent > 60) return { down: 0, up: 40 };
        if (percent > 50) return { down: 0, up: 20 };
        if (percent > 40) return { down: 20, up: 0 };
        if (percent > 30) return { down: 40, up: 0 };
        if (percent > 20) return { down: 60, up: 0 };
        if (percent > 10) return { down: 80, up: 0 };
        if (percent >= 0) return { down: 100, up: 0 };
        else return { down: 0, up: 0 };
    };

    const checkIsMobile = () => {
        let getSize = window.innerWidth;
        if (getSize < 468) {
            return false;
        }
        return true;
    };

    const updateDataHandler = () => {
        containerRef.current.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        props.getMapCharacteristicsAction(
            props.map.id,
            1,
            allowActionsHandler,
            "new"
        );
    };

    const unauthorizedHandler = () => {
        let myColor = { background: "#f44336", text: "#FFFFFF" };
        notify.show("Please register or login first.", "custom", 3000, myColor);
    };

    const handleChangeRate = (value, itemId) => {
        //if (!localStorage.getItem("access_token")) return unauthorizedHandler();
        const form = new FormData();
        form.append("parent_id", itemId);
        form.append("value", value);
        form.append("map_id", props.map.id);
        props.changeRateAction(form, updateDataHandler);
    };

    const showDescription = (data) => {
        return data.map((item) => {
            const rating = calculateRating(item.upPercent);
            return (
                <Grid
                    container
                    key={item.id}
                    alignItems="center"
                    className={classes.grid}
                >
                    <Grid item  xs={4} md={3} style={{ display: "flex" }}>
                        <ToggleButton
                            value="more"
                            className={classes.more}
                            onClick={() => handleChangeRate(1, item.id)}
                        >
                            <ExpandLessIcon style={{ color: "#313131" }} />
                        </ToggleButton>
                        <ToggleButton
                            value="less"
                            className={classes.less}
                            onClick={() => handleChangeRate(-1, item.id)}
                        >
                            <ExpandMoreIcon style={{ color: "#313131" }} />
                        </ToggleButton>
                    </Grid>
                    <Grid item xs={8} md={9}>
                        <div className={classes.inner}>
                            <div className={classes.leftSection}>
                                <div
                                    className={classes.down}
                                    style={{ width: `${rating.down}%` }}
                                ></div>
                            </div>
                            <div className={classes.rightSection}>
                                <div
                                    className={classes.up}
                                    style={{ width: `${rating.up}%` }}
                                ></div>
                            </div>
                            <div className={classes.charContainer}>
                                <div className={classes.characteristics}>
                                    {item.title}
                                </div>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            );
        });
    };

    const allowActionsHandler = () => {
        setSendDReq(true);
    };

    const handleToggleDrawInstruments = () => {
        setIsOpenSelect(!isOpenSelect);
    };

    const [isPanelExpanded, setIsPanelExpanded] = useState(false);
    const handlePanelToggle = () => {
        setIsPanelExpanded(!isPanelExpanded);
    };

    return (
        <>
            {isMobile && (
                <div style={{ display: "flex", justifyContent: "end" }}>
                    {!isPanelExpanded && (
                        <div
                            className={classes.openMountainIcon}
                            onClick={handleToggleDrawInstruments}
                        >
                            {isOpenSelect ? (
                                <CloseOutlinedIcon
                                    className={`${classes.white}`}
                                />
                            ) : (
                                <ArrowBackIosIcon
                                    className={`${classes.white} ${classes.left}`}
                                />
                            )}
                        </div>
                    )}
                    {!isOpenSelect ? (
                        <div className={classes.iconMountaon}>
                            <LandscapeIcon className={classes.white} />
                        </div>
                    ) : (
                        <ExpansionPanel
                            defaultExpanded={checkIsMobile()}
                            style={{ width: "100%", boxShadow: "none", maxWidth: isPanelExpanded ? "338px" : "305px" }}
                            expanded={isPanelExpanded}
                            onChange={handlePanelToggle}
                        >
                            <ExpansionPanelSummary
                                style={{
                                    backgroundColor: "#313131",
                                    borderTopRightRadius: "4px",
                                    borderBottomRightRadius: "4px",
                                    minHeight: "9vw",
                                    height: "9vw",
                                    borderBottomLeftRadius: !isPanelExpanded ? "0px" : "4px",
                                    borderTopLeftRadius: !isPanelExpanded ? "0px" : "4px",
                                }}
                                expandIcon={
                                    <ExpandMoreIcon
                                        style={{ color: "white" }}
                                    />
                                }
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography
                                    className={classes.heading}
                                    style={{
                                        fontFamily: "'Bebas Neue', cursive",
                                        color: "white",
                                        fontSize: isMobile ? "18px" : "",
                                    }}
                                >
                                    Mountain Characteristics
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid container spacing={2} alignItems="center">
                                    <div
                                        className={classes.scroll}
                                        ref={containerRef}
                                    >
                                        {props.characteristics &&
                                            props.characteristics &&
                                            showDescription(
                                                props.characteristics
                                            )}
                                    </div>
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                    )}
                </div>
            )}
            <div className={isMobile ? classes.rootMobile : classes.root}>
                {!isMobile && (
                    <ExpansionPanel defaultExpanded={checkIsMobile()}>
                        <ExpansionPanelSummary
                            style={{
                                backgroundColor: "#313131",
                                border: "4px solid white",
                                borderRadius: "8px",
                            }}
                            expandIcon={
                                <ExpandMoreIcon style={{ color: "white" }} />
                            }
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography
                                className={classes.heading}
                                style={{
                                    fontFamily: "'Bebas Neue', cursive",
                                    color: "white",
                                }}
                            >
                                Mountain Characteristics
                            </Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <Grid container spacing={2} alignItems="center">
                                <div
                                    className={classes.scroll}
                                    ref={containerRef}
                                >
                                    {props.characteristics &&
                                        props.characteristics &&
                                        showDescription(props.characteristics)}
                                </div>
                            </Grid>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                )}
            </div>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        description: state.characteristics.description,
        errors: state.characteristics.errors,
        map: state.map.map,
        page: state.characteristics.page,
        characteristics: state.characteristics.data,
        pagination: state.characteristics.characteristics,
    };
};

const mapDispatchToProps = {
    setDescriptionValueAction,
    clearDescriptionFieldAction,
    addCharacteristicAction,
    cleanDescriptionErrorsAction,
    getMapCharacteristicsAction,
    changeRateAction,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MountainCharacteristic);
